import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, Typography, Alert, IconButton, CircularProgress,
  TextField, Button,
} from '@mui/material';
import { Home, Tune } from '@mui/icons-material';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function TransportSetupPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ oneWayPercent: 60, defaultMonthsInTerm: 3 });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };

  const load = async () => {
    try { const { data } = await axios.get(`${API}/api/fleet/setup`, { headers }); setForm({ oneWayPercent: data.oneWayPercent, defaultMonthsInTerm: data.defaultMonthsInTerm }); setError(''); }
    catch (err) { setError(err.response?.data?.error || 'Failed to load'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const save = async () => {
    try {
      await axios.put(`${API}/api/fleet/setup`, {
        oneWayPercent: Number(form.oneWayPercent), defaultMonthsInTerm: Number(form.defaultMonthsInTerm),
      }, { headers });
      setError('Saved successfully');
    } catch (err) { setError(err.response?.data?.error || 'Failed to save'); }
  };

  if (loading) return (<Box sx={{ maxWidth: 600, mx: 'auto', mt: 4, textAlign: 'center' }}><CircularProgress /></Box>);

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Card elevation={3}>
        <CardContent>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <Box display="flex" alignItems="center"><Tune sx={{ mr: 1, color: '#455a64' }} /><Typography variant="h5" sx={{ color: '#455a64' }}>Transport Setup</Typography></Box>
            <IconButton onClick={() => navigate('/fleet')} title="Fleet Dashboard"><Home /></IconButton>
          </Box>
          {error && <Alert severity={error.includes('success') ? 'success' : 'error'} sx={{ mb: 2 }}>{error}</Alert>}
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField label="One-way fee (% of monthly fee)" type="number" value={form.oneWayPercent}
              onChange={e => setForm({ ...form, oneWayPercent: e.target.value })} size="small" fullWidth
              helperText="One-way learners pay this % of the location's monthly fee" inputProps={{ min: 0, max: 100 }} />
            <TextField label="Default months per term" type="number" value={form.defaultMonthsInTerm}
              onChange={e => setForm({ ...form, defaultMonthsInTerm: e.target.value })} size="small" fullWidth
              helperText="Transport fee = monthly fee × this, when the term doesn't set its own" inputProps={{ min: 1, max: 12 }} />
            <Button variant="contained" onClick={save}>Save</Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
